import React, { useContext, useEffect, useState } from 'react';
import { switchArrayItems } from 'utils/helpers';
import LanguageBarItem from 'components/LanguageBarItem/LanguageBarItem';
import { ICustomerLanguage } from 'types';
import {
	CustomerFullInfoContext,
	ICustomerFullInfoContext,
} from '../../../../../../../../customerFullInfoState/customerFullInfoContext';
import style from './LanguageBar.module.scss';

interface ILanguageBar {
	items: ICustomerLanguage[];
}

const LanguageBar: React.FC<ILanguageBar> = ({ items }) => {
	const { setLocalizationLanguage, selectedLocalizationLanguage, customerForFullInfo } =
		useContext<ICustomerFullInfoContext>(CustomerFullInfoContext);
	const [orderedLanguages, setOrderedLanguages] = useState<ICustomerLanguage[]>([]);

	useEffect(() => {
		const indexOfDefaultLanguage = items.findIndex(
			(el) => el.languageId === customerForFullInfo?.defaultLanguageId,
		);
		const orderedByDefaultLanguage = switchArrayItems(items, indexOfDefaultLanguage, 0);
		setOrderedLanguages(orderedByDefaultLanguage);
	}, [items, customerForFullInfo?.defaultLanguageId]);

	useEffect(() => {
		const initialLanguage = orderedLanguages.length
			? { id: orderedLanguages[0].languageId, name: orderedLanguages[0].languageName }
			: null;
		setLocalizationLanguage(selectedLocalizationLanguage ? selectedLocalizationLanguage : initialLanguage);
	}, [selectedLocalizationLanguage, orderedLanguages]);

	return (
		<>
			{orderedLanguages.length ? (
				<div className={style.container}>
					{orderedLanguages.map((el) => (
						<LanguageBarItem
							key={el.languageId}
							languageId={el.languageId}
							isActive={selectedLocalizationLanguage?.id === el.languageId}
							onClick={() => setLocalizationLanguage({ id: el.languageId, name: el.languageName })}
						/>
					))}
				</div>
			) : null}
		</>
	);
};

export default React.memo(LanguageBar);
